import { defineStepper } from '@stepperize/react'

import { EStepperType } from '../constants'

export const stepper = defineStepper(
  { id: EStepperType.ADD_USERS },
  { id: EStepperType.ASSIGNED_ACCESS }
)
